import { Box, Typography, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface PlanUnitDetailsCategoryParams {
  children?: React.ReactElement[];
  categoryName: string;
}

const PlanUnitDetailsCategory = ({
  children,
  categoryName
}: PlanUnitDetailsCategoryParams) => {
  const { t } = useTranslation('common', { keyPrefix: 'costCenters.details' });

  return (
    <Box
      width="calc(50% - 16px)"
      display="flex"
      flexDirection="column"
      gap={0.5}
    >
      <Typography variant="h6">{t(categoryName)}</Typography>

      <Divider sx={{ mt: 0.5 }} />

      {children}
    </Box>
  );
};

export default PlanUnitDetailsCategory;
